import React from 'react';
import { translation } from '../helper/translation';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const NoAccessPage = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        navigate('/');
    };

    const handleClearAndReload = () => {
        // Clear all cookies
        document.cookie.split(';').forEach(cookie => {
            document.cookie = cookie
                .replace(/^ +/, '')
                .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });

        // Clear localStorage and sessionStorage
        localStorage.clear();
        sessionStorage.clear();

        // Reload the page
        window.location.reload();
    };

    return (
        <div className="no-access-page">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="no-access-content">
                            <h1>{translation('no-access-title')}</h1>
                            <div className="warning-icon">⚠️</div>
                            <h2>{translation('no-access-message')}</h2>
                            <div className="action-buttons">
                                <Button variant="primary" onClick={handleReturnHome}>
                                    {translation('no-access-return')}
                                </Button>
                                <Button variant="outline-secondary" onClick={handleClearAndReload}>
                                    {translation('no-access-clear')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}; 